import { useState } from "react";
import { Link } from "react-router-dom";
import { toTitleCase } from "../../js/utils/titleCase";

export default function Rollup({ title, children, defaultOpen = false, badge, to, tour }) {
  const [open, setOpen] = useState(defaultOpen);
  const heading = toTitleCase(title);

  return (
    <section className="rollup" data-tour={tour || undefined}>
      <div className="rollup__title">
        {to ? (
          <Link to={to}>{heading}</Link>
        ) : (
          <button type="button" onClick={() => setOpen((current) => !current)}>
            {heading}
          </button>
        )}
        <button type="button" onClick={() => setOpen((current) => !current)} aria-expanded={open}>
          <span className="muted">
            {badge ? `${badge} · ` : ""}
            {open ? "Hide" : "Open"}
          </span>
        </button>
      </div>
      {open ? <div className="rollup__body">{children}</div> : null}
    </section>
  );
}
